import React, { useEffect, useState } from 'react';
import coinImage from '../assets/images/coin-image.png';
import CoinPurchaseComp from '../components/globals/CoinPurchaseComp';
import { apiGetAuth, apiPost } from '../utils/Api';
import { ENDPOINTS } from '../utils/EndPoint';
import { useNavigate } from 'react-router-dom';
import CustomPrimaryButton from '../components/globals/CustomPrimaryButton';
import CustomModal from '../components/globals/CustomModal';
import { isLoaderState, snakeBarState } from '../store/RecoilStore';
import { useRecoilState } from 'recoil';
import CustomSecondaryButton from '../components/globals/CustomSecondaryButton';
import { userAtom } from '../store/authAtom';


function CoinPurchase() {
  const [coins, setCoins] = useState([]);
  const [savedCards, setSavedCards] = useState([]);
  const [isLoaderInfo, setIsLoaderInfo] = useRecoilState(isLoaderState);
  const [isConfirmPurchaseModalVisible, setIsConfirmPurchaseModalVisible] = useState(false);
  const [isSelectCardModalVisible, setIsSelectCardModalVisible] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [selectedPackageId, setSelectedPackageId] = useState(null);
  const [snackBarInfo, setSnackBarInfo] = useRecoilState(snakeBarState);
  const [showGuestModal, setGuestModal] = useState(false);
  const [user, setUser] = useRecoilState(userAtom);



  const navigate = useNavigate();

  const getPackages = () => {
    apiGetAuth(
      ENDPOINTS.GetPackages,
      (res) => {
        if (res) {
          setCoins(res);
        }
      },
      (error) => {
        console.log(error, "Challenges Year Bar");
      }
    );
  };

  useEffect(() => {
    if (coins) {
      setGuestModal(true);
    }
  }, [coins]);

  const showPaymentModal = () => {
    setIsSelectCardModalVisible(true);
    setIsConfirmPurchaseModalVisible(false);
  }

  const getSavedCards = () => {
    apiGetAuth(
      ENDPOINTS.ListCard,
      (res) => {
        if (res) {
          setSavedCards(res);
          const defaultCard = res.find(card => card.default_card === 1);
          if (defaultCard) {
            setSelectedCard(defaultCard.id);
          }
        }
      },
      (error) => {
        console.log(error, "Error fetching saved cards");
      }
    );
  };

  const handleSaveSelectCard = async (cardId) => {
    setIsLoaderInfo(true);

    try {
      const payload = {
        card_id: cardId,
      };

      await apiPost(ENDPOINTS.SetDefaultCard, payload, (res) => {
        setSnackBarInfo({ message: "Default card updated", type: "success" });
        getSavedCards();
        setSelectedCard(cardId);
      }, (err) => {
        const errorMessage = err?.data?.data || "Failed to update default card";
        setSnackBarInfo({
          snackStatus: true,
          snackColor: "bg-danger",
          snackMsg: errorMessage,
        });
      });
    } catch (error) {
      console.error("Error updating default card:", error);
    } finally {
      setIsLoaderInfo(false);
    }
  };

  useEffect(() => {
    getPackages();
    getSavedCards();
  }, []);

  const handleBuyPackage = () => {
    if (!selectedCard || !selectedPackageId) {

      navigate("/admin/cards");

      setSnackBarInfo({
        snackStatus: true,
        snackColor: "bg-danger",
        snackMsg: "Please select a card and package before proceeding.",
      });

      return;
    }

    const payload = {
      card_id: selectedCard,
      package_id: selectedPackageId,
    };

    apiPost(
      ENDPOINTS.BuyWebPackage,
      payload,
      (res) => {
        setIsConfirmPurchaseModalVisible(false);
        setIsSelectCardModalVisible(false);
        setSnackBarInfo({
          snackStatus: true,
          snackColor: "bg-primary",
          snackMsg: "Package purchased successfully!",
        });
      },
      (error) => {
        const errorMessage = error?.data?.message || "Failed to purchase package.";
        setSnackBarInfo({
          snackStatus: true,
          snackColor: "bg-danger",
          snackMsg: errorMessage,
        });
      }
    );
  };

  const handleSelectPackage = (packageId) => {
    setSelectedPackageId(packageId);
    setIsConfirmPurchaseModalVisible(true);
  };

  const handleSelectCard = (cardId) => {
    setSelectedCard(cardId);
  };

  return (
    <div className='coin-purchase'>
      <div className='container'>
        <div className='d-flex justify-content-between align-items-center'>
          <h1 className='pt-4 text-white'>Coin Purchase:</h1>
          <CustomPrimaryButton
            btnTextPro="Cards"
            classNamePro=""
            handleOnClick={() => {
              navigate("/admin/cards");
            }}
          />
        </div>
        <div className='row mt-5'>
          {coins.map((item, index) => (
            <div className='col-lg-4 mb-4' key={index}>
              <CoinPurchaseComp
                wallettext={item.description}
                walletamount={`$${item.amount}`}
                walletimage={coinImage}
                handleOnClick={() => handleSelectPackage(item?.id)}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Confirm Purchase Modal */}
      <CustomModal
        size={'md'}
        hideModal={() => setIsConfirmPurchaseModalVisible(false)}
        showModal={isConfirmPurchaseModalVisible}
        title="Confirm Purchase"
        onClose={() => setIsConfirmPurchaseModalVisible(false)}
      >
        <div className="container text-center">
          <h5 className="text-white mb-4">Are you sure you want to buy this package?</h5>
          <p className="text-white">You will be charged based on your selected card.</p>
          <div className="d-flex justify-content-center mt-4">
            <CustomPrimaryButton
              btnTextPro="Select Card & Buy"
              classNamePro="btn btn-primary mt-2"
              handleOnClick={showPaymentModal}
            />
            <CustomSecondaryButton
              btnTextPro="Cancel"
              classNamePro="btn btn-seondary"
              handleOnClick={() => setIsConfirmPurchaseModalVisible(false)}
            />
          </div>
        </div>
      </CustomModal>

      {/* Select Card Modal */}
      <CustomModal
        size={'md'}
        hideModal={() => setIsSelectCardModalVisible(false)}
        showModal={isSelectCardModalVisible}
        title="Select Card"
        onClose={() => setIsSelectCardModalVisible(false)}
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h4 className="text-white">Select your payment method</h4>
              <div className="mt-4">
                {savedCards.length === 0 ? (
                  <p className='text-white'>No saved cards available.</p>
                ) : (
                  savedCards.map((card) => (
                    <div key={card.id} className="d-flex justify-content-between align-items-center mb-3">
                      <div>
                        <input
                          type="radio"
                          name="selectedCard"
                          value={card.id}
                          checked={selectedCard === card.id}
                          onChange={() => handleSaveSelectCard(card.id)}
                          className="form-check-input"
                        />
                        <span className="ms-2 text-white font-18">
                          {card.cardholder_name} - **** **** **** {card.last4digit}
                        </span>
                      </div>
                      {card.default_card === 1 && (
                        <span className="badge bg-info text-white rounded-pill py-1 px-2">Default Card</span>
                      )}
                    </div>
                  ))
                )}
              </div>
              <CustomPrimaryButton
                btnTextPro="Confirm Purchase"
                handleOnClick={() => handleBuyPackage(selectedPackageId)}
              />
            </div>
          </div>
        </div>
      </CustomModal>


      {user?.type === "guest_user" && (
        <CustomModal
          size="md"
          hideModal={() => navigate("/admin/ocean")}
          showModal={showGuestModal}
          title="Select Ocean"
        >
          <div className="ocean-modal text-center">
            <h2 className='text-white font-24 text-bold skranji-regular'>This feature is not available for guest users</h2>
            <div class="buttons d-flex justify-content-center">
              <CustomSecondaryButton
                btnTextPro="Cancel"
                classNamePro="btn btn-seondary"
                handleOnClick={() => navigate("/admin/ocean")}
              />
              <CustomPrimaryButton
                btnTextPro="Sign Up"
                classNamePro="btn btn-primary mt-2"
                handleOnClick={() => {
                  navigate("/register-form");
                }}
              />
            </div>
          </div>
        </CustomModal>
      )}
    </div>
  );
}

export default CoinPurchase;
